import { element, bool } from 'prop-types';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

export const unitTestOptions = {
	defaultOptions: {
		queries: {
			retry: false,
		},
	},
};

const DataFetchingWrapper = ({ children, hasOwnProvider }) => {
	const queryClientOptions =
		process.env.NODE_ENV === 'test' ? unitTestOptions : {};
	const queryClient = new QueryClient(queryClientOptions);

	return hasOwnProvider ? (
		children
	) : (
		// Only add the QueryClientProvider if the consuming app doesn't have it. (Having 2 providers can cause redundant API calls.)
		<QueryClientProvider client={queryClient}>
			{children}
			{/*  We only want the devtools (the red flower on the bottom left) to show in dev mode */}
			{process.env.NODE_ENV === 'development' && (
				<ReactQueryDevtools initialIsOpen={false} />
			)}
		</QueryClientProvider>
	);
};

DataFetchingWrapper.propTypes = {
	/**
	 * The component we want to enable data fetching on.
	 */
	children: element.isRequired,
	/**
	 * The component to show when the data is loading.
	 */
	hasOwnProvider: bool.isRequired,
};

export default DataFetchingWrapper;
